"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHAR_ATLAS_CELL_SPACING = 1;